import { createApp } from 'vue'
import '@/utils/http'
import App from './App.vue'
import router from './router'

// Import Element Plus
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './styles/admin-page.css'
import './styles/responsive.css'
import './styles/site-pages.css'
import './styles/exam-take.css'
import './styles/user-settings.css'
import './styles/imagebar-compact.css'
import { goToLogin } from '@/utils/loginFlow'

const app = createApp(App)

app.config.globalProperties.$goToLogin = function (returnPath) {
  return goToLogin(router, returnPath ?? this.$route?.fullPath)
}

app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.mount('#app')